// extracted by mini-css-extract-plugin
module.exports = {"SettingsSubscriptionButton":"SettingsSubscriptionButton_SettingsSubscriptionButton__bzpkp"};